module.exports = __webpack_public_path__ + "static/img/pelvic-img-right.3efc2913.png";